import styled from '@emotion/styled';
import { Avatar, Grid } from '@mui/material';
import Button from 'components/Button';
import FixedWidth from 'components/FixedWidth';
import refer from './ink-art-refer.svg';

const StyledContent = styled.div`
  padding: 3rem 0 6rem 0;
  background: #f2f4f7;
  text-align: center;
  h2 {
    text-align: center;
    color: #001e61;
    font-weight: 300;
  }
  h3 {
    font-family: 'DM Serif Text', sans-serif;
    font-weight: 600;
    line-height: 1.21;
    text-align: center;
    font-size: 1.5rem;
    color: #001e61;
  }
  .MuiAvatar-root {
    margin: 0 auto;
    background: #edc6cd;
    color: #20275c;
    border: 1px solid #20275c;
    font-family: 'DM Serif Text', sans-serif;
    font-weight: 600;
    line-height: 1.21;
  }
  .MuiGrid-root {
    text-align: center;
  }

  @media (max-width: 756px) {
    padding-right: 16px;
    padding-left: 16px;
    text-align: justify;
    text-justify: inter-word;
    ul {
      li {
        font-size: 14px;
      }
    }
    & img {
      max-width: 794px;
      @media (max-width: 756px) {
        width: 100%;
      }
    }
  }
`;

export default function ForBusinessesBlocks(): JSX.Element {
  return (
    <StyledContent>
      <FixedWidth>
        <h2>Fast, easy and low-cost hiring</h2>
        <p>
          At Inkwell, we are committed to helping companies build strong and
          inclusive teams that drive success. Let us help you find your next top
          performer.
        </p>
        <picture>
          <img src={refer} alt="" width="344px" />
        </picture>
        <Grid
          container
          spacing={6}
          justifyContent="center"
          alignItems="flex-start"
          alignContent="center"
        >
          <Grid item xs={12} md={4}>
            <Avatar>1</Avatar>
            <h3>Submit a job request</h3>
            <p>
              Provide us with a detailed job description, requirements, and
              company culture.
            </p>
          </Grid>
          <Grid item xs={12} md={4}>
            <Avatar>2</Avatar>
            <h3>Meet with an Inkwell expert.</h3>
            <p>We will gather more details and answer your questions.</p>
          </Grid>
          <Grid item xs={12} md={4}>
            <Avatar>3</Avatar>
            <h3>Hire your next great employee</h3>
            <p>
              We send you a vetted list of candidates from our AI-enabled
              networks.
            </p>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4} sx={{ p: 6 }}>
          <Button
            href="/for-businesses/new-business"
            color="primary"
            variant="contained"
          >
            Get started
          </Button>
        </Grid>
      </FixedWidth>
    </StyledContent>
  );
}
